//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

//Image to SVG
function imgToSvg() {
  let convertImages = (query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("width") +
              " " +
              svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};

// keenslider navigation
function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createButton(className) {
    var div = document.createElement("button");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createButton("arrow arrow--left");
    arrowLeft.setAttribute("tabindex", "0");
    arrowLeft.setAttribute("aria-label", "previous slide");
    arrowLeft.setAttribute("role", "button");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowLeft.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowLeft.click();
      }
    });
    arrowRight = createButton("arrow arrow--right");
    arrowRight.setAttribute("tabindex", "0");
    arrowRight.setAttribute("aria-label", "next slide");
    arrowRight.setAttribute("role", "button");
    arrowRight.addEventListener("click", () => slider.next());
    arrowRight.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowRight.click();
      }
    });

    innerWrapper.appendChild(arrowLeft);
    innerWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("slider-wrapper");
    innerWrapper = createDiv("slider-navigation");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
    wrapper.appendChild(innerWrapper);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createButton("dot");
      dot.setAttribute("tabindex", "0");
      dot.setAttribute("aria-label", "navigate to slide " + (idx + 1));
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dot.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          dot.click();
        }
      });
      dots.appendChild(dot);
    });
    innerWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}
// keenslider init
function newsSlider() {
  if ($(".fhw.slider").length > 0) {
    var slider = new KeenSlider(
      "#newsSlider",
      {
        breakpoints: {
          "(min-width: 500px)": {
            slides: { perView: 2, spacing: 10 },
          },
          "(min-width: 991px)": {
            slides: { perView: 3.125, spacing: 32, origin: "center" },
          },
        },
        loop: true,
        slides: { perView: 1.12, spacing: 10 },
      },
      [navigation],
    );
  }
}

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

// Universal Accordion Script
// Works with ANY accordion that has .js-accordion class
function initAccordions() {
  // Close all accordions by default on page load
  $(".js-accordion").each(function () {
    var $accordion = $(this);
    var $button = $accordion.find(".js-accordion__button");
    var $content = $accordion.find(".js-accordion__content");

    $button.attr("aria-expanded", "false");
    $content.attr("aria-hidden", "true").hide();
  });

  // Use event delegation to handle dynamically shown/hidden content
  $(document)
    .off("click", ".js-accordion__button")
    .on("click", ".js-accordion__button", function (e) {
      e.preventDefault();

      var $button = $(this);
      var $accordion = $button.closest(".js-accordion");
      var $content = $accordion.find(".js-accordion__content");
      var isExpanded = $button.attr("aria-expanded") === "true";

      // Optional: Close sibling accordions in the same container
      var $siblings = $accordion.siblings(".js-accordion");
      $siblings.each(function () {
        var $sibling = $(this);
        $sibling.find(".js-accordion__button").attr("aria-expanded", "false");
        $sibling
          .find(".js-accordion__content")
          .attr("aria-hidden", "true")
          .slideUp(300);
      });

      // Toggle current accordion
      if (isExpanded) {
        $button.attr("aria-expanded", "false");
        $content.attr("aria-hidden", "true").slideUp(300);
      } else {
        $button.attr("aria-expanded", "true");
        $content.attr("aria-hidden", "false").slideDown(300);
      }
    });
}

//tab
function initTabs() {
  // Initialize tabs on page load - show only active tab content
  $(".jsTabNav").each(function () {
    var $nav = $(this);
    var $container = $nav.closest(".eco");
    var $tabList = $container.find(".jsTabList");
    var $activeLink = $nav.find("a.is-active");
    var activeCat = $activeLink.attr("data-category");

    // Hide all items and show only active category
    var $items = $tabList.children();
    $items.hide();
    if (activeCat) {
      $items.filter("." + activeCat).show();
    }
  });

  // Tab click handler
  $(".jsTabNav a").on("click", function (e) {
    e.preventDefault();

    var $clickedLink = $(this);
    var catValue = $clickedLink.attr("data-category");
    var $nav = $clickedLink.closest(".jsTabNav");
    var $container = $clickedLink.closest(".eco");
    var $tabList = $container.find(".jsTabList");

    // Close all accordions within THIS tab set when switching
    $tabList
      .find(".js-accordion__button[aria-expanded='true']")
      .each(function () {
        var $btn = $(this);
        var $accordion = $btn.closest(".js-accordion");
        var $content = $accordion.find(".js-accordion__content");
        $btn.attr("aria-expanded", "false");
        $content.attr("aria-hidden", "true").hide();
      });

    // Update Nav active state
    $nav.find("a").removeClass("is-active").attr("aria-pressed", "false");
    $clickedLink.addClass("is-active").attr("aria-pressed", "true");

    // Filter Items
    var $items = $tabList.children();
    $items.hide();
    $items.filter("." + catValue).show();
  });
}

$(document).ready(function () {
  // imgToSvg();
  current__year();
  initAccordions();
  initTabs();
});

$(window).on("load", function () {
  // hamburger__click();
  // newsSlider();
  cursorClick();
});
